import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const LastName = props => (
  <BaseInput
    label="Last Name"
    type="text"
    name="last"
    inputTip="enter exactly as it appears on your driver&#39;s license"
    transparent
    data-cv-test="lastName"
    validate={val =>
      string()
        .required('Enter your last name')
        .min(2, 'Last name must be greater than 1 character')
        .max(30, 'Last name cannot be greater than 30 characters')
        .matches(/^[a-zA-Z0-9 \-']+$/, {
          message: 'Enter a valid last name',
          excludeEmptyString: true
        })
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

LastName.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

LastName.defaultProps = {
  error: false
};

export default LastName;
